import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@mui/material'
import { Typography } from '@mui/material'

import {
  CardBlockInfo,
  CardBody
} from 'packages/ui/CardPreview'

const EquipmentsCount = ({ equipment, name, keyUp, keyTotal }) => {
  const background = useMemo(() => {
    return equipment[keyUp] === equipment[keyTotal] && equipment[keyTotal] != 0
      ? '#F4F8ED'
      : equipment[keyUp] === 0 && equipment[keyTotal] != 0
        ? '#FEF2F2'
        : 'white'
  }, [equipment, keyUp, keyTotal])
  const border = useMemo(() => {
    return equipment[keyUp] === equipment[keyTotal] && equipment[keyTotal] != 0
      ? '1px solid #E6F0D7'
      : equipment[keyUp] === 0 && equipment[keyTotal] != 0
        ? '1px solid #FEF2F2'
        : '1px solid #F6F6F6'
  }, [equipment, keyUp, keyTotal])
  return (
    <Box
      sx={{
        display: 'flex',
        width: '30%',
        minWidth: '100px',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: background,
        border: border,
        borderRadius: '8px',
        padding: '8px 16px',
        gap: '4px',
      }}
    >
      <Typography
        sx={{
          color: '#7A8096',
          fontWeight: 500,
          fontSize: '9px',
          textTransform: 'uppercase',
        }}
      >
        {name}
      </Typography>
      <Box sx={{ display: 'flex' }}>
        <Typography
          sx={{
            color: '#5D5F70',
            fontWeight: 400,
            fontSize: '14px',
          }}
        >
          {equipment[keyUp]}
        </Typography>
        <Typography sx={{ fontWeight: 400, color: '#A2AAB8' }}>/</Typography>
        <Typography
          sx={{
            color: '#A2AAB8',
            fontWeight: 400,
            fontSize: '14px',
          }}
        >
          {equipment[keyTotal]}
        </Typography>
      </Box>
    </Box>
  )
}

const Infos = ({ site }) => {
  const { t } = useTranslation()

  return (
    <CardBody>
      <Stack gap={0}>
        <CardBlockInfo
          title={t('supervision.card.devices')}
          subtitle={
            site.equipment.nb_active_users
              ? site.equipment.nb_active_users
              : '-'
          }
        />
        <Box
          sx={{
            display: 'flex',
            flexFlow: 'wrap',
            padding: '16px 4px 0 4px',
            gap: '14px',
          }}
        >
          {site.equipment.nb_firewalls > 0 && (
            <EquipmentsCount
              name={t('supervision.equipment.firewall')}
              equipment={site.equipment}
              keyUp={'nb_firewalls_ok'}
              keyTotal={'nb_firewalls'}
            />
          )}
          {site.equipment.nb_accesspoints > 0 && (
            <EquipmentsCount
              name={t('supervision.equipment.ap')}
              equipment={site.equipment}
              keyUp={'nb_accesspoints_ok'}
              keyTotal={'nb_accesspoints'}
            />
          )}
          {site.equipment.nb_switches > 0 && (
            <EquipmentsCount
              name={'Switches'}
              equipment={site.equipment}
              keyUp={'nb_switches_ok'}
              keyTotal={'nb_switches'}
            />
          )}
          {site.equipment.nb_chromecasts > 0 && (
            <EquipmentsCount
              name={'Chromecasts'}
              equipment={site.equipment}
              keyUp={'nb_chromecasts_ok'}
              keyTotal={'nb_chromecasts'}
            />
          )}
          {site.equipment.nb_tvs > 0 && (
            <EquipmentsCount
              name={'TVs'}
              equipment={site.equipment}
              keyUp={'nb_tvs_ok'}
              keyTotal={'nb_tvs'}
            />
          )}
          {site.equipment.nb_esls > 0 && (
            <EquipmentsCount
              name={'Eegs'}
              equipment={site.equipment}
              keyUp={'nb_esls_ok'}
              keyTotal={'nb_esls'}
            />
          )}
          {site.equipment.nb_inverters > 0 && (
            <EquipmentsCount
              name={t('supervision.equipment.inverter')}
              equipment={site.equipment}
              keyUp={'nb_inverters_ok'}
              keyTotal={'nb_inverters'}
            />
          )}
          {site.equipment.nb_cctv_cameras > 0 && (
            <EquipmentsCount
              name={t('supervision.equipment.cctv_camera')}
              equipment={site.equipment}
              keyUp={'nb_cctv_cameras_ok'}
              keyTotal={'nb_cctv_cameras'}
            />
          )}
          {site.equipment.nb_cctv_servers > 0 && (
            <EquipmentsCount
              name={t('supervision.equipment.cctv_server')}
              equipment={site.equipment}
              keyUp={'nb_cctv_servers_ok'}
              keyTotal={'nb_cctv_servers'}
            />
          )}
        </Box>
      </Stack>
    </CardBody>
  )
}

export default Infos
